import React from 'react'

const FindWork = () => {
  return (
    <div>FindWork</div>
  )
}

export { FindWork }
